import produce from "immer";
// import amplitude from 'amplitude-js';
import { createAction, handleActions } from 'redux-actions';
import { appAmplitudeEventFunc } from "../utils/appEventFunc";

const user_properties = {
  "일반 정보": {
    "current_email": '',
    "current_nickname": '',
    "self_rated_level": '',
    "account_creation_date": '',
  },
  "진단Test": {
    "진단test 이행 여부": '',
    "진단test level": '',
    "현재 level": '',
  },
  "방문경향": {
    "총 방문 횟수": '',
    "첫 방문 일자": '',
    "최근 방문 일자": '',
    "평균 세션 시간": '',
  },
  "학습결과": {
    "total_unique_curriculum_types": '',
    "total_unique_stages": '',
    "course_learning_completed": '',
    "subject_learning_completed": '',
    "ocr_learning_completed": '',
    "review_learning_completed": '',
    "question_solving_completed": '',
    "first_learning_date": '',
    "latest_learning_date": '',
  },
  "구독상태": {
    "Premium 여부": ''
  }
};

const event_properties = {
  name: '',
  event: {
    business_Question: '',
    event_Description: '',
    property_Type: '',
    property_Name: '',
    sample_Values: '',
    property: '',
    description: '',
  }
};

const defaultState = {
  user_properties,
  event_properties,
  question_data: null,
}

const SET_USER_PROPERTIES = 'amplitude/SET_SET_USER_PROPERTIES';
const SET_EVENT_PROPERTIES = 'amplitude/SET_EVENT_PROPERTIES';
const SET_LOG_QUESTION_DATA = 'amplitude/SET_LOG_QUESTION_DATA';

export const setUserProperties = createAction(SET_USER_PROPERTIES, (data) => data);
export const setEventProperties = createAction(SET_EVENT_PROPERTIES, (data) => data);
export const setQuestionData = createAction(SET_LOG_QUESTION_DATA, (data) => data);

const userGeneralInfo = (state, data) => produce(state, draft => {
  draft.user_properties["일반 정보"] = data.info;
  draft.user_properties["진단Test"] = data.aiTest;
  draft.user_properties["방문경향"] = {
    "최근 방문 일자": data.lrnCmnInfo["최근 방문 일자"],
    "최근 학습 일자": data.lrnCmnInfo["최근 학습 일자"]
  };
  draft.user_properties["구독상태"] = data.subscribeInfo;
});

const eventInfo = (state, data) => produce(state, draft => {
  draft.event_properties = data;
});


const amplitudeLogData = handleActions(
  {
  [SET_USER_PROPERTIES]: (state, { payload: data }) => {
      switch (data.property_name) {
        case '일반 정보':
          const info = userGeneralInfo(state, data)
          // amplitude.getInstance().setUserId(info.user_properties['일반 정보'].current_email);
          // amplitude.getInstance().setUserProperties(info.user_properties);

          // const onceIdentify = new amplitude.Identify()
          //   .setOnce("방문경향.첫 방문 일자", data.lrnCmnInfo["첫 방문 일자"])
          //   .setOnce("방문경향.첫 학습 일자", data.lrnCmnInfo["첫 학습 일자"])
          //   .setOnce("일반 정보.account_creation_date", data.info.account_creation_date)
          
          // amplitude.getInstance().identify(onceIdentify);
          // const userId = info.user_properties['일반 정보'].current_email;

          const setUserProperties = {
            userId: data.userId,
            userProperties: info.user_properties,
            idenfityOnce: [
              { name: '방문경향.첫 방문 일자', value: data.lrnCmnInfo["첫 방문 일자"] },
              { name: '방문경향.첫 학습 일자', value: data.lrnCmnInfo["첫 학습 일자"] },
              { name: '일반 정보.account_creation_date', value: data.info.account_creation_date },
            ]
          }

          appAmplitudeEventFunc(setUserProperties, 'setAmplitude');
          return info;
      }
    },
    [SET_EVENT_PROPERTIES]: (state, { payload: data}) => {
      // if (data?.name) amplitude.getInstance().logEvent(data.name, data.event);

      if (data?.name) {
        const setLogEvent = {
          type: 'logEvent',
          name: data.name,
          value: data.event
        }

        console.log(`***** amplitude: ${JSON.stringify(setLogEvent, null, 2)}`);

        appAmplitudeEventFunc(setLogEvent, 'logAmplitude');
      }

      return eventInfo(state, data);
    },

    [SET_LOG_QUESTION_DATA]: (state, { payload: data}) => {
      
      return produce(state, draft => {
        draft.question_data = data;
      });
    }
  },
  defaultState
);

export default amplitudeLogData;